import PropTypes from "prop-types";
import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";
import axios from "axios";
import ProductGridListSingleSelectedProduct from "../../components/product/ProductGridListSingleSelectedProduct";

const ProductGrid = ({
  products,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  compareItems,
  sliderClassName,
  spaceBottomClass,
  setFavoriteProducts,
  favoriteProducts,
  physioMode,
  selectedProduct
}) => {

  const [avalaibleColors, setAvalaibleColors] = useState([]);

  const fetchColorsData = () => {
    let query = 'https://public-front-api.therunningcollective.fr/detailed-colors?headCategory=all'
    axios
        .get(query)
        .then((res) => {
          setAvalaibleColors(res.data);
        })
        .catch((err) => {
          console.log(err);
        })
  };

  useEffect(() => {
    fetchColorsData();
  }, []);

  return (
    <Fragment>
      {
        selectedProduct && selectedProduct.shortURL != "" ?
          <ProductGridListSingleSelectedProduct
            sliderClassName={sliderClassName}
            spaceBottomClass={spaceBottomClass}
            product={selectedProduct}
            currency={currency}
            addToCart={addToCart}
            addToWishlist={addToWishlist}
            addToCompare={addToCompare}
            avalaibleColors={avalaibleColors}
            setFavoriteProducts={setFavoriteProducts} 
            favoriteProducts={favoriteProducts}
            physioMode={physioMode}
            cartItem={
              cartItems.filter(cartItem => cartItem.id === selectedProduct.id)[0]
            }
            wishlistItem={
              wishlistItems.filter(
                  wishlistItem => wishlistItem.id === selectedProduct.id
              )[0]
            }
            compareItem={
              compareItems.filter(
                  compareItem => compareItem.id === selectedProduct.id
              )[0]
            }
            key={selectedProduct.id}
            index={0}
        />
        : null 
      }
      {products.map((product, index) => {
        return (
            <ProductGridListSingle
                sliderClassName={sliderClassName}
                spaceBottomClass={spaceBottomClass}
                product={product}
                currency={currency}
                addToCart={addToCart}
                addToWishlist={addToWishlist}
                addToCompare={addToCompare}
                avalaibleColors={avalaibleColors}
                setFavoriteProducts={setFavoriteProducts} 
                favoriteProducts={favoriteProducts}
                physioMode={physioMode}
                cartItem={
                  cartItems.filter(cartItem => cartItem.id === product.id)[0]
                }
                wishlistItem={
                  wishlistItems.filter(
                      wishlistItem => wishlistItem.id === product.id
                  )[0]
                }
                compareItem={
                  compareItems.filter(
                      compareItem => compareItem.id === product.id
                  )[0]
                }
                key={product.id}
                index={index}
            />
        );
      })}
    </Fragment>
  );
};

ProductGrid.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  products: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItems: PropTypes.array,
  favoriteProducts: PropTypes.any,
  setFavoriteProducts: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize
        )
      );
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGrid);
